import request from '@/http/request';

export function getAutoDispatchUser(data) {
  return request({
    url: '/api/v1/ops/auto_dispatch_user',
    method: 'post',
    data: data,
  });
}

export function updateAutoDispatchUser(data) {
  return request({
    url: '/api/v1/ops/update_auto_dispatch_user',
    method: 'post',
    data: data,
  });
}

export function addAutoDispatchUser(data) {
  return request({
    url: '/api/v1/ops/add_auto_dispatch_user',
    method: 'post',
    data: data,
  });
}
export function voiceFeedbackList(data) {
  return request({
    url: '/api/v1/ops/voice_feedback_list',
    method: 'post',
    data: data,
  });
}
